// get cart items
export const GET_CART_ITEMS_LOADING = "GET_CART_ITEMS_LOADING";
export const GET_CART_ITEMS_SUCCESS = "GET_CART_ITEMS_SUCCESS";
export const GET_CART_ITEMS_ERROR = "GET_CART_ITEMS_ERROR";

// add item to cart
export const ADD_ITEM_TO_CART_LOADING = "ADD_ITEM_TO_CART_LOADING";
export const ADD_ITEM_TO_CART_SUCCESS = "ADD_ITEM_TO_CART_SUCCESS";
export const ADD_ITEM_TO_CART_ERROR = "ADD_ITEM_TO_CART_ERROR";

// update cart items
export const UPDATE_CART_ITEMS_LOADING = "UPDATE_CART_ITEMS_LOADING";
export const UPDATE_CART_ITEMS_SUCCESS = "UPDATE_CART_ITEMS_SUCCESS";
export const UPDATE_CART_ITEMS_ERROR = "UPDATE_CART_ITEMS_ERROR";

// REMOVE cart items
export const REMOVE_CART_ITEMS_LOADING = "REMOVE_CART_ITEMS_LOADING";
export const REMOVE_CART_ITEMS_SUCCESS = "REMOVE_CART_ITEMS_SUCCESS";
export const REMOVE_CART_ITEMS_ERROR = "REMOVE_CART_ITEMS_ERROR";
